export default {
  title: 'Agent Earn',
  myCommission: 'My Commission',
  teamSize: 'Team Size',
  teamDeposit: 'Team Deposit',
  teamContribute: 'Team Contrib.',
  teamBet: 'Team Betting',
  newYesterday: 'New Yesterday',
  newMonth: 'New This Month',
  activeMonth: 'Monthly Active',
  teamWinLoss: 'Team Win/Loss',
  serviceCenter: 'Service Center',
  members: 'Members',
  memberData: 'Member Data',
  memberProxyDeposit: 'Proxy Deposit',
  liveConsume: 'Live Spending',
  memberSearchPlaceholder: 'Sub-agent ID',
  memberSearch: 'Search',
  memberColUser: 'User',
  memberColContrib: 'Contrib.',
  memberColAction: 'Action',
  memberId: 'ID: {id}',
  memberEdit: 'Edit member',
  memberEmpty: 'No member data found',
  memberEmptyHint: 'Check the sub-agent ID and search again',
  memberNotFound: 'Direct member not found',
  memberDataUpdated: 'Member data updated',
  memberLoadMore: 'Load more',
  memberLoading: 'Loading…',
  memberNoMore: 'No more',
  materials: 'Promo Assets',
  materialsInvitePrefix: 'Invite friends to',
  materialsInviteSub: 'You and your friends both earn commissions',
  materialsCardTitle: '{brand} Exclusive Invite',
  materialsCardDesc: 'Share your link — friends bind automatically after signup',
  materialsQrHint: 'Scan with your mobile browser to join',
  materialsCopyLink: 'Copy Link',
  materialsSaveQr: 'Save QR',
  materialsSaveOk: 'QR code saved',
  materialsSaveFail: 'Save failed — long-press the image to save',
  gameRecords: 'Game Records',
  gameRecordTime: 'Time',
  gameRecordMember: 'Member',
  gameRecordMemberPlaceholder: 'Enter member ID',
  gameRecordUpdated: 'Game records updated by selected filters',
  gameRecordBetTotal: 'Bet Amount: ',
  gameRecordProfitTotal: 'P/L: ',
  gameRecordBetCount: 'Bets',
  gameRecordBetAmount: 'Stake',
  gameRecordWinAmount: 'Winnings',
  gameRecordViewDetail: 'Details >',
  gameRecordEmpty: 'No game records',
  gameRecordEmptyHint: 'No platform records found for this member',
  gameRecordBackSummary: 'Back to summary',
  gameRecordOrdersTitle: '{name} Bets',
  gameRecordBetTime: 'Bet Time',
  gameRecordBetContent: 'Bet Content',
  gameRecordOrderStatus: 'Status',
  gameRecordOrderNo: 'Order No.',
  gameRecordSettled: 'Settled',
  gameRecordPending: 'Pending',
  gameRecordCancelled: 'Cancelled',
  gameRecordLoading: 'Loading…',
  gameRecordLoadMore: 'Load more',
  gameRecordNoMore: 'No more',
  withdrawNow: 'Withdraw',
  incomeWithdraw: 'Income Withdrawal',
  withdrawRecords: 'Records',
  withdrawNotice: 'Double-check receiving details; transfers to others cannot be recovered',
  withdrawableAmount: 'Withdrawable',
  withdrawingAmount: 'In Progress',
  transferringAmount: 'Transferring',
  withdrawToAccount: 'To Account',
  withdrawToAccountSub: 'External payout account',
  withdrawToBalance: 'To Balance',
  withdrawToBalanceSub: 'Directly to wallet balance',
  withdrawAmount: 'Amount',
  withdrawManageAccount: 'Manage accounts',
  withdrawAll: 'All',
  withdrawArrivalAmount: 'Receivable: {amount}',
  withdrawSelectAccount: 'Select payout account',
  withdrawChangeAccount: 'Change',
  withdrawPickTitle: 'Select withdrawal account',
  withdrawAddMethod: 'Add payout method',
  withdrawNoAccount: 'No payout account',
  withdrawScheduleHint:
    'Requests can be submitted on the 1st–31st; payouts are issued within 1–5 days.',
  withdrawAmountRequired: 'Enter a withdrawal amount',
  withdrawExceed: 'Amount cannot exceed the withdrawable balance of {amount}',
  withdrawExceedLimit: 'Amount cannot exceed the per-transaction limit of {amount}',
  withdrawBelowMin: 'Amount cannot be below {amount}',
  withdrawSelectAccountRequired: 'Select a payout account',
  withdrawSubmitted: 'Withdrawal request submitted',
  transferSubmitted: 'Transferred to balance',
  transferProcessing: 'Transfer in progress',
  withdrawAccounts: 'Payout Accounts',
  waMultiSelect: 'Select',
  waDone: 'Done',
  waLockLabel: 'Account locked',
  waLockHint: 'Enable multi-select to manage this account',
  waDelete: 'Delete account',
  waDeleteSuccess: '{name} account deleted',
  waAddAccount: 'Add Account',
  waEmpty: 'No payout accounts',
  waEmptyHint: 'Add a payout account to submit withdrawal requests',
  waSheetTitle: 'Add Payout Method',
  waFormTitle: 'Add {name}',
  waNoticeAccount: 'Double-check the account number; transfers to others cannot be recovered',
  waNoticeAddress: 'Double-check the wallet address; transfers to others cannot be recovered',
  waNoticeBank: 'Double-check the bank card details; transfers to others cannot be recovered',
  waNoticeBankCard: 'Double-check the card number; transfers to others cannot be recovered',
  waChainType: 'Chain',
  waNetwork: 'Network',
  waCurrency: 'Currency',
  waRegion: 'Region',
  waRegionPh: 'Select region',
  waRegionRequired: 'Please select a region first',
  waPickRegion: 'Select Region',
  waPickBank: 'Select Bank',
  waBankSearchPh: 'Search banks',
  waBankAccount: 'Account Number',
  waBankAccountPh: 'Enter account number',
  waBranch: 'Branch',
  waBranchPh: 'Enter branch name',
  waBankNamePh: 'Select bank',
  waRegionCn: 'China',
  waRegionJp: 'Japan',
  waRegionTw: 'Taiwan',
  waRegionHk: 'Hong Kong',
  waRegionMo: 'Macau',
  waRegionSg: 'Singapore',
  waBankBoc: 'Bank of China',
  waBankIcbc: 'ICBC',
  waBankCcb: 'CCB',
  waBankAbc: 'ABC',
  waBankBocom: 'Bank of Communications',
  waBankCitic: 'CITIC Bank',
  waBankCmb: 'China Merchants Bank',
  waBankSpdb: 'SPDB',
  waBankCib: 'Industrial Bank',
  waBankCmbc: 'China Minsheng Bank',
  waBankCeb: 'China Everbright Bank',
  waBankHxb: 'Hua Xia Bank',
  waBankPingan: 'Ping An Bank',
  waHolder: 'Real Name',
  waHolderPh: 'Enter your real name',
  waCardHolder: 'Card Holder',
  waCardHolderPh: 'Enter the card holder name',
  waBankName: 'Bank',
  waCardNo: 'Card Number',
  waCardNoPh: 'Enter the card number',
  waAccount: 'Account',
  waAccountPh: 'Enter the account number',
  waAddress: 'Wallet Address',
  waAddressPh: 'Enter the wallet address',
  waUsdtAddressPh: 'USDT ({network}) wallet address',
  waPaste: 'Paste',
  waPasteFail: 'Paste failed — please enter it manually',
  waSubmit: 'Add Now',
  waAddSuccess: '{name} account added',
  waFieldRequired: 'Please enter {label}',
  waSelectFieldRequired: 'Please select {label}',
  waChOkpay: 'OKpay',
  waChGopay: 'GOpay',
  waChBank: 'Bank Card',
  waChUsdt: 'USDT',
  waChBobi: 'Bobi Wallet',
  waChKdou: 'Kdou Wallet',
  waChWanbi: 'Wanbi Wallet',
  waChJjpay: 'JJPAY',
  waChVippay: 'VIPpay',
  transferAmount: 'Transfer Amount',
  transferRealtime: 'Instant',
  transferAmountPlaceholder: 'Available {amount}',
  transferArrivalBalance: 'To balance: {amount}',
  transferToAccount: 'Destination',
  transferUnchangeable: 'Cannot change',
  transferToBalancePre: 'Transfer to',
  transferToBalanceName: 'Balance',
  transferTagRealtime: 'Instant',
  transferTagNoFee: 'No fee',
  transferTagNoBind: 'No binding',
  transferTagParity: '1:1 credit',
  transferDesc:
    'Transfer to balance: income goes directly to your balance for immediate game use, no withdrawal review.',
  transferHelp: 'Help',
  transferSubmit: 'Confirm transfer to balance',
  billRecords: 'Bill Details',
  billTabRecharge: 'Deposit',
  billTabWithdraw: 'Withdraw',
  billTabRebate: 'Rebate',
  billTabRedpacket: 'Red Packet',
  billTabReward: 'Reward',
  billTypeFilter: 'Type',
  billChannel: 'Channel',
  billSource: 'Source',
  billTime: 'Time',
  billChannelBank: 'Bank card',
  billChannelCrypto: 'Crypto',
  billChannelBalance: 'Account balance',
  billWithdrawApply: 'Withdrawal request',
  billPromoWithdraw: 'Promotion withdrawal',
  billTypeAllRecharge: 'All deposits',
  billTypeBankRecharge: 'Bank card deposit',
  billTypeCryptoRecharge: 'Crypto deposit',
  billTypeAllWithdraw: 'All withdrawals',
  billTypeWithdrawAccount: 'Withdraw to account',
  billTypeTransferBalance: 'Transfer to balance',
  billTypeAllRebate: 'All rebates',
  billTypeRealtimeRebate: 'Real-time rebate',
  billRebateSourceAll: 'All',
  billTypeAllRedpacket: 'All red packets',
  billTypeSendRedpacket: 'Sent red packet',
  billTypeClaimRedpacket: 'Claimed red packet',
  billTypeAllReward: 'All rewards',
  billTypeChestReward: 'Chest task',
  billTypeSignInReward: 'Check-in reward',
  billStatus: {
    received: 'Credited',
    unprocessed: 'Pending',
    reviewing: 'Reviewing',
    success: 'Success',
    failed: 'Failed',
  },
  billEmpty: 'No bill records',
  billEmptyTitle: 'No bill records yet',
  billEmptyHint: 'Your bill records have been cleared. New transactions will appear here.',
  billFilterEmpty: 'No bill records',
  billLoading: 'Loading…',
  billLoadMore: 'Load more',
  billMore: 'More',
  billDeleteHint: 'This will delete all your current bill records',
  billDeleteNoData: 'No data in current list',
  billDeleteAll: 'Delete all bills',
  billCancel: 'Cancel',
  billConfirm: 'Confirm',
  billDeleteConfirmTitle: 'Delete all bills?',
  billDeleteConfirmPrefix: 'This action ',
  billDeleteConfirmEm: 'cannot be undone',
  billDeleteConfirmSuffix: '. Please proceed with caution.',
  billDeleteSuccess: 'Deleted successfully',
  commissionReport: 'Commission Report',
  reportTime: 'Time',
  reportTo: 'to',
  reportTotal: '{period} total · {count}',
  reportTotalCustom: 'Selected dates total · {count}',
  reportDirectCommission: 'Direct Comm.',
  reportIndirectCommission: 'Indirect Comm.',
  reportGameCommission: 'Game Comm.',
  reportLiveCommission: 'Live Comm.',
  reportDetails: 'Commission Details',
  reportDetailsSub: 'View every rebate record',
  reportColNick: 'Nickname',
  reportColTime: 'Time',
  reportColType: 'Type',
  reportColAmount: 'Amount',
  reportBasisTurnover: 'Turnover rebate',
  reportBasisNgr: 'Net win/loss rebate',
  reportBasisRakeback: 'Rakeback share',
  reportSourceDaily: 'Daily rebate',
  reportSourceAdjustment: 'Late adjustment',
  reportDepthDirect: 'Direct downline',
  reportTypeLottery: 'Lottery',
  reportTypeGame: 'Game',
  reportTypeLive: 'Live',
  reportEmpty: 'No commission records',
  reportEmptyHint: 'Credits post on the settlement cycle after valid team contributions',
  reportDetailEmpty: 'No commission details',
  reportDetailEmptyHint: 'No rebates in the selected dates',
  reportPickDate: 'Select Date',
  reportPickStart: 'Select start date',
  reportPickEnd: 'Select end date',
  reportRangeSelected: 'Date range selected',
  reportHeaderDate: '{m}/{d} ({w})',
  reportHeaderDateEn: '{w}, {month} {d}',
  reportMonthTitle: '{y}/{m}',
  reportMonthTitleEn: '{month} {y}',
  reportPrevMonth: 'Previous month',
  reportNextMonth: 'Next month',
  reportCancel: 'Cancel',
  reportConfirm: 'OK',
  commissionPlan: 'Comm. Plan',
  planFilter: 'Filter',
  planConfirm: 'Confirm',
  planAll: 'All',
  planAllLabel: 'All Plans',
  planSummary: '{name} · {count}',
  planTiers: '{n} tiers',
  planColPlan: 'Plan',
  planColTrigger: 'Trigger Vol.',
  planColCap: 'Cap',
  planColRatio: 'Rate',
  planEmpty: 'No commission plans',
  bindRelation: 'Bind Relation',
  bindSubTitle: 'Bind Subordinate',
  bindSubId: 'Sub ID',
  bindCode: 'Bind Code',
  bindSubIdPlaceholder: 'Enter subordinate ID',
  bindCodePlaceholder: 'Enter bind code',
  bindSubIdRequired: 'Enter a subordinate ID',
  bindCodeRequired: 'Enter a bind code',
  submitting: 'Submitting…',
  bindConfirm: 'Confirm Bind',
  bindSuccess: 'Bound Successfully',
  bindSuccessDesc: 'Sub ID {id} bound successfully (code {code})',
  bindViewRelation: 'View Relations',
  bindTipsTitle: 'Tips',
  bindTip1: 'Agents can use this to recover subordinates whose binding failed.',
  bindTip2: 'Bind codes are in “Relations → My Card” and disappear after binding.',
  relation: 'Upline/Downline',
  relationMyCard: 'My Card',
  relationMySuperior: 'My Upline',
  relationId: 'ID: {id}',
  relationBindCode: 'Bind code: {code}',
  relationCopyCard: 'Copy Card',
  relationNoSuperior: 'No upline yet',
  exclusiveCs: 'Support',
  comingSoon: 'Coming soon',
  teamStatsTruncated: 'Data too large, please check the commission report',
}
